import type { SeatAwareUserTeam } from '@/types/seatAccess'

export function hasEffectiveSeatAccess(
  membership: Pick<
    SeatAwareUserTeam,
    'seatAccessState' | 'seatGraceEndsAt' | 'onSeat'
  > & { id?: string | null; status?: string | null },
  now = Date.now(),
): boolean {
  if (!membership.seatAccessState) return true
  if (membership.seatAccessState === 'EXEMPT') return true
  if (membership.seatAccessState === 'PAID') return membership.onSeat !== false
  if (membership.seatAccessState !== 'GRACE') return false
  const deadline = Date.parse(membership.seatGraceEndsAt ?? '')
  return Number.isFinite(deadline) && now < deadline
}

export function formatSeatGraceDate(
  value: string | null | undefined,
  locale: string,
): string | null {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(date)
}
